import { STEP_STATUS, StepStatus } from '@shared/types/enums';
import StepItem from './StepItem';
import { StepItemConfig } from '@shared/types/step';

interface StepBarProp {
    currentStep: number,
    stepConfig: StepItemConfig[]
}

export default function StepBar(props: StepBarProp) {
    // props
    const { currentStep, stepConfig } = props;

    const totalSteps = stepConfig.length;

    return (
        <div
            className='flex h-[48px] sm:h-[60px] w-full overflow-hidden rounded-[8px] bg-white'
            style={{ '--step-arrow': '16px' } as React.CSSProperties}
        >
            <style>
                {`
                    @media (min-width: 640px) {
                        .step-item { --step-arrow: 40px; }
                    }
                `}
            </style>
            {
                stepConfig.length > 0 && stepConfig.map((stepItem, index) => {
                    let step = stepItem.step;

                    let stepStatus: StepStatus = STEP_STATUS.DISABLE;

                    if (step === currentStep) {
                        stepStatus = STEP_STATUS.ACTIVE;
                    } else if (step < currentStep) {
                        stepStatus = STEP_STATUS.PASS;
                    }

                    return (
                        <StepItem
                            key={step}
                            stepStatus={stepStatus}
                            content={stepItem.content}
                            isFirst={index === 0}
                            isLast={index >= totalSteps - 1}
                            zIndex={totalSteps - index}
                        />
                    );
                })
            }
        </div>
    );
}
